/**
 * API客户端错误处理
 * 统一的错误分类和处理逻辑
 */
import { ApiError } from './types.js';
/**
 * 网络错误类型
 */
export var NetworkErrorType;
(function (NetworkErrorType) {
    NetworkErrorType["TIMEOUT"] = "TIMEOUT";
    NetworkErrorType["CONNECTION_ERROR"] = "CONNECTION_ERROR";
    NetworkErrorType["NOT_FOUND"] = "NOT_FOUND";
    NetworkErrorType["UNAUTHORIZED"] = "UNAUTHORIZED";
    NetworkErrorType["FORBIDDEN"] = "FORBIDDEN";
    NetworkErrorType["SERVER_ERROR"] = "SERVER_ERROR";
    NetworkErrorType["UNKNOWN"] = "UNKNOWN";
})(NetworkErrorType || (NetworkErrorType = {}));
/**
 * 创建API错误
 */
export function createApiError(message, code, status, data) {
    return new ApiError(message, code, status, data);
}
/**
 * 根据HTTP状态码创建错误
 */
export function createErrorFromStatus(status, message) {
    switch (status) {
        case 400:
            return createApiError(message || 'Bad Request', 'BAD_REQUEST', status);
        case 401:
            return createApiError(message || 'Unauthorized', 'UNAUTHORIZED', status);
        case 403:
            return createApiError(message || 'Forbidden', 'FORBIDDEN', status);
        case 404:
            return createApiError(message || 'Not Found', 'NOT_FOUND', status);
        case 409:
            return createApiError(message || 'Conflict', 'CONFLICT', status);
        case 422:
            return createApiError(message || 'Validation Error', 'VALIDATION_ERROR', status);
        case 429:
            return createApiError(message || 'Too Many Requests', 'RATE_LIMIT', status);
        case 500:
            return createApiError(message || 'Internal Server Error', 'SERVER_ERROR', status);
        case 502:
            return createApiError(message || 'Bad Gateway', 'BAD_GATEWAY', status);
        case 503:
            return createApiError(message || 'Service Unavailable', 'SERVICE_UNAVAILABLE', status);
        default:
            if (status >= 400 && status < 500) {
                return createApiError(message || 'Client Error', 'CLIENT_ERROR', status);
            }
            else if (status >= 500) {
                return createApiError(message || 'Server Error', 'SERVER_ERROR', status);
            }
            return createApiError(message || 'Unknown Error', 'UNKNOWN', status);
    }
}
/**
 * 判断是否为网络错误
 */
export function isNetworkError(error) {
    return (error instanceof TypeError &&
        (error.message.includes('fetch') ||
            error.message.includes('network') ||
            error.message.includes('Failed to fetch')));
}
/**
 * 判断是否为超时错误
 */
export function isTimeoutError(error) {
    if (error instanceof Error) {
        return (error.name === 'AbortError' ||
            error.message.includes('timeout') ||
            error.message.includes('aborted'));
    }
    return false;
}
/**
 * 判断错误是否可重试
 */
export function isRetryableError(error) {
    // 网络错误可重试
    if (isNetworkError(error) || isTimeoutError(error)) {
        return true;
    }
    // 特定HTTP状态码可重试
    if (error.status) {
        return (error.status === 429 || // 速率限制
            error.status === 502 || // 网关错误
            error.status === 503 || // 服务不可用
            error.status === 504); // 网关超时
    }
    return false;
}
/**
 * 安全地提取错误信息
 */
export function extractErrorMessage(errorData) {
    if (typeof errorData === 'object' && errorData !== null) {
        const error = errorData;
        if (typeof error.error === 'string') {
            return error.error;
        }
        if (typeof error.message === 'string') {
            return error.message;
        }
    }
    return undefined;
}
//# sourceMappingURL=errors.js.map